import DadosLocais from '@/services/helper/storage'
import { Constantes } from "@/services/helper/constantes";
import axios from "axios";
const dadosLocais = DadosLocais.getInstance()

class LogService {
    /**
     * Item 49 do edital -- registra um evento de atividade originado no front (navegação de
     * tela, clique de ação em BarraBotoes ou qualquer outro botão, seleção de módulo, etc.).
     * Genérico de propósito: qualquer tela/componente pode chamar sem precisar de endpoint
     * novo por evento.
     */
    async registrarAtividade(
        tipoEvento: string,
        descricao: string,
        opts?: { rota?: string; modulo?: string },
    ): Promise<any> {
        try {
            // Dev local: esta chamada vai sempre pra Kernel API real (nunca roda em localhost),
            // então é cross-site de verdade — SameSite=Lax não manda o cookie de volta. A Kernel
            // API só devolve o token no corpo pra esse cenário (ver EhOrigemDesenvolvimentoLocal,
            // Kernel API) — usa esse valor pra montar o header aqui.
            const headers: Record<string, string> = {};
            if (location.hostname === 'localhost') {
                const token = dadosLocais.getAccessToken();
                if (token) {
                    headers['Authorization'] = `Bearer ${token}`;
                }
            }

            await axios.post(`${Constantes.URL_KERNEL_API}/AtividadeUsuario/RegistrarAtividadeFront`,
                {
                    tipoEvento,
                    descricao,
                    rota: opts?.rota,
                    modulo: opts?.modulo,
                },
                { withCredentials: true, headers }
            );

            return true;
        } catch (exception: any) {
            return null;
        }
    }
}
export default new LogService();
